import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import { viewModelConverter } from "./converter";
import { errorMapper, isDirtyMapper, isEditedMapper, type ZodSchemaType } from "./mapper";

type InputModelToViewModelConverterProps<I, E, Q, Z> = {
	defaultInput: AutoGeneratorForFormModel<I, E, Q>["InputModel"];
	initInput?: AutoGeneratorForFormModel<I, E, Q>["InputModel"];
	currentInput: AutoGeneratorForFormModel<I, E, Q>["InputModel"];
	excludeKeys: Array<string>;
	zodSchema: ZodSchemaType<Z>;
};

/**
 *
 * @template {I} - InitInputModel
 * @template {E} - ExcludeKeys
 * @template {Q} - QueryData
 * @template {Z} - ZodSchema
 */
export const inputModelToViewModelConverter = <I, E, Q, Z>(props: InputModelToViewModelConverterProps<I, E, Q, Z>) => {
	const { defaultInput, initInput, currentInput, excludeKeys, zodSchema } = props;

	let viewModel = viewModelConverter(currentInput, excludeKeys) as AutoGeneratorForFormModel<I, E, Q>["ViewModel"];

	// isDirty を ViewModel へマージ
	viewModel = isDirtyMapper(viewModel, currentInput, initInput);

	// zodError を ViewModel へ マージ
	viewModel = errorMapper(viewModel, excludeKeys, currentInput, zodSchema);

	// 変更フラグを ViewModel へマージ
	viewModel = isEditedMapper(viewModel, excludeKeys, currentInput, defaultInput);

	return viewModel;
};
